import axios from 'axios';
import qs from 'query-string';

import env from 'environments';

const instance = axios.create({
  baseURL: env.PAYMENTS_URL,
  paramsSerializer: qs.stringify,
});

export const getInstance = () => instance;
